// @flow
import type { ComboBoxOptions } from 'bench-internal-theme';
import { compareAsStrings } from 'comparators';

export const addOnTypeLabels = {
  BENCH_TAX: 'Bench Tax',
  CASH_RECONCILIATION: 'Cash Reconciliation',
  CHECKS: 'Checks',
  CUSTOM_ADJUSTEMENTS: 'Custom Adjustments',
  INTERCOMPANY_LOAN: 'Intercompany Loan',
  LOAN_LOC_CAPITAL_LEASE: 'Loan / LOC / Lease',
  MERCHANT_PROCESSOR: 'Merchant Processor',
  OTHER: 'Other',
  PAYROLL: 'Payroll Provider',
  PERSON_CONTRIBUTION: 'Personal Contribution',
  PERSONAL_BUSINESS_CROSSOVER: 'Personal-Business Crossover',
  PRO: 'PRO',
  RECEIPTS: 'Receipts',
  REIMBURSEMENTS: 'Reimbursements',
  TAGGING_AND_REPORTING: '1099 Tagging & Reporting',
};

export const addOnTypeOptions: Array<{ label: string, value: any }> = Object.keys(
  addOnTypeLabels,
).map(key => ({
  label: addOnTypeLabels[key],
  value: key.toString(),
}));

const compareOptionLabels = (optionA, optionB) => compareAsStrings(optionA.label, optionB.label);

type AddOn = {
  id: string,
  name: string,
  accountType: $Keys<typeof addOnTypeLabels>,
};

export const mapAddOnsToOptions = (addOns: Array<AddOn>): ComboBoxOptions =>
  addOns
    .map(({ accountType, id, name }) => ({
      value: id,
      label: `${name} - ${addOnTypeLabels[accountType]}`,
    }))
    .sort(compareOptionLabels);

type DataWithIdAndName = {
  id: string,
  name: string,
};

export const mapDataWithIdAndNameToOptions = (data: Array<DataWithIdAndName>): ComboBoxOptions =>
  data.map(option => ({ value: option.id, label: option.name })).sort(compareOptionLabels);
